import { render, staticRenderFns } from "./ReportTimeframe.vue?vue&type=template&id=af382afa"
import script from "./ReportTimeframe.vue?vue&type=script&lang=js"
export * from "./ReportTimeframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports